import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

class SelectEscuelasItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };

    this.buscarEscuelas = debounce(this.buscarEscuelas.bind(this), 300);
  }

  componentDidMount() {
    this.buscarEscuelas("", true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value) {
        const buscarEscuela = this.state.opciones.find(
          (e) => e._id.toString() === this.props.value.toString(),
        );

        if (buscarEscuela) {
          this.props.onChange?.(buscarEscuela._id, buscarEscuela);
        } else if (!this.state.cargando) {
          this.buscarEscuelas(this.props.value || "", true);
        }
      }
    }
  }

  async buscarEscuelas(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "escuelas/selectEscuelasItem",
        {
          query: append
            ? this.state.texto || texto || this.props.value
            : inicial && texto?.length === 24 && /^[a-f\d]{24}$/i.test(texto)
              ? ""
              : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      );

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append
            ? [...prev.opciones, ...res.data.escuelas]
            : res.data.escuelas,
          primerCarga: false,
          texto: append ? this.state.texto : texto,
        }));

        if (inicial && res.data.escuelas.length > 0) {
          const escuelaTarget = this.props.value
            ? res.data.escuelas.find(
                (e) => e._id.toString() === this.props.value.toString(),
              )
            : null;

          if (escuelaTarget) {
            this.props.onChange?.(escuelaTarget._id, escuelaTarget);
          } else if (this.props.autoseleccionar) {
            this.props.onChange?.(
              res.data.escuelas[0]._id,
              res.data.escuelas[0],
            );
          }
        }
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar escuelas:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      this.setState({
        cargando: false,
        texto: append ? this.state.texto : texto,
      });
    }
  }

  render() {
    const {
      noBuscar,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      onSearch: this.buscarEscuelas,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: "center", padding: "8px" }}>
          <div style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}>
            Buscando escuelas...
          </div>
        </div>
      ) : this.state.primerCarga ? (
        "Cargando..."
      ) : (
        "No se encontraron escuelas"
      ),
      loading: this.state.cargando,
    };

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? (fondoBlanco ? "white" : "white") : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0, 0, 0, 0.1)",
      width: width || "100%",
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const escuela = this.state.opciones.find((e) => e._id === value);
          if (this.props.onChange) this.props.onChange(value, escuela);
        }}
        placeholder={
          this.state.cargando && this.state.primerCarga
            ? "Cargando..."
            : placeholder
        }
        style={estiloFinal}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarEscuelas(this.props.value || "", false, true);
          }
        }}
      >
        {this.state.opciones.map((escuela) => (
          <Option key={escuela._id} value={escuela._id}>
            {escuela.stringBuscar || escuela.nombre || ""}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectEscuelasItem;
